import {create} from 'zustand'
import {Media} from '@features/video-upload/types.ts'

export interface VideoUploadStore {
    assignmentId: number | null
    darylDirectoryId: string | null
    file: Media | null
    dropzoneFile: File | null
    isOpen: boolean
    linkMediaToUpload: string | null
    step: 'fetching' | 'idle' | 'gettingLink' | 'uploading' | 'uploaded'
    setDropzoneFile: (dropzoneFile: File | null) => void
    setFile: (file: Media | null) => void
    setIsOpen: (isOpen: boolean, assignmentId?: number, darylDirectoryId?: string | null) => void
    setLinkMediaToUpload: (linkMediaToUpload: string | null) => void
    setStep: (step: VideoUploadStore['step']) => void
}

export const useVideoUpload = create<VideoUploadStore>(set => ({
    assignmentId: null,
    darylDirectoryId: null,
    dropzoneFile: null,
    file: null,
    isOpen: false,
    linkMediaToUpload: null,
    step: 'fetching',
    setDropzoneFile: dropzoneFile => set({dropzoneFile}),
    setFile: file => set({file}),
    setIsOpen: (isOpen, assignmentId, darylDirectoryId) => {
        if (isOpen) {
            set({assignmentId, darylDirectoryId, isOpen})
        } else {
            set({
                assignmentId: null,
                darylDirectoryId: null,
                dropzoneFile: null,
                file: null,
                isOpen: false,
                linkMediaToUpload: null,
                step: 'fetching'
            })
        }
    },
    setLinkMediaToUpload: linkMediaToUpload => set({linkMediaToUpload}),
    setStep: step => set({step})
}))
